module.exports = __webpack_public_path__ + "static/media/apple-pay.bcb42021.png";